<style lang="less">
 @import './side.less';
</style>
<template>
	<div class="m_navbar_content">
		<div class="m_logo_content"></div>
		<div class="m_menu_content">
			<el-menu
	        :default-active="active"
	        class="el-menu-vertical-demo"
	        :collapse="isCollapse"
	        background-color="#001529"
	        text-color="#fff"
      		active-text-color="#fff"
	        @select="change"
	        align="left"
	      	>
	        <el-submenu :index="item.menuId" v-for="item in navList" :key="item.menuId" v-if="!item.menuDisabled">
	          <template slot="title">
	            <i :class="item.menuIcon"></i>
	            <span slot="title">{{ item.menuName }}</span>
	          </template>
	          <el-menu-item
	            :index="childItem.menuPath"
	            v-for="childItem in item.menus"
	            :key="childItem.menuId"
	            v-if="!childItem.menuDisabled"
	            >{{ childItem.menuName }}</el-menu-item>
	        </el-submenu>
	      </el-menu>
      </div>
	</div>
</template>

<script>
	import storage from '@/utils/storage'
	export default{
		 name: "Side",
		 props:{
		 	isCollapse:{
		 		type:Boolean,
		 		default:false
		 	}
		 },
		data(){
			return{
//				isCollapse: false,
				active:'/authority',
				navList:[],
				token: storage.get('token')
			}
		},
		computed: {
			userInfo() {
		        return this.$store.state.member.userInfo;
		  },
		},
		created(){
			console.log(this.$route,this.navList )
			this.active = this.$route.path;
			if(this.userInfo !=null && this.token != null){
				this.navload();
			}
		},
		methods:{
			navload(){
				this.navList=[];
				this.$http.main.menuTree().then((res) => {
						if(res.return_code==0) {
							
							this.navList = res.data;
						}
						else {
						  	this.$message({
								message: this.$t(res.return_key),
								type: 'error',
								duration:3000
							});
						}
					}, (err) => {
						  this.$message({
							message: err,
							type: 'error',
							duration:3000
						});
					});
			},
			change(item){
				console.log(item);
				this.$router.push(item)
			}
		},
		watch: {
		    $route(value) {
		      this.active = value.path;
		    }
  		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Side/index.vue